module.exports = "././img/dlgrma_logo_white.png";


//////////////////
// WEBPACK FOOTER
// ../assets/img/dlgrma_logo_white.png
// module id = 820
// module chunks = 0